export const ROUTES = [
  {
    path: "/dashboard",
    title: "Dashboard",
    icon: "dashboard",
    children: null,
  },

  {
    path: "#user-management",
    id: "user-management",
    title: "Admin",
    tooltip: "Links available to the admin users only.",
    icon: "people",
    children: [
      {
        path: "user-management",
        title: "User",
        tooltip:
          "list of all users. Can edit user detail and make an user inactive.",
        icon: "chevron_right",
      
      },
      {
        path: "bulkRegister",
        title: "Bulk Register",
        tooltip:
          "Upload spreadsheet to bulk user registration using downloadable sample file.",
        icon: "chevron_right"
      },
       
    ],
  },
  {
    path: "#masters",
    id: "masters",
    title: "Master Data",
    tooltip: "Master items list with Create/Edit/Delete operations.",
    icon: "extension",
    children: [
      {
        path: "masters/state-master",
        title: "State Master",
        tooltip: "Indian state list. Only view is available.",
        icon: "chevron_right"
      },
      {
        path: "masters/city-master",
        title: "City Master",
        tooltip:
          "Indian cities list as per master data application. Only view is available.",
        icon: "chevron_right"
      },
      {
        path:"masters/bulk-city",
        title:"Bulk City",
        tootip: "Bulk creation of Cities",
        icon:"chevron_right"
      },
      {
        path: "masters/product-master",
        title: "Product Master",
        tooltip: "Create/edit/delete/list products.",
        icon: "chevron_right"
      },
      {
        path: "masters/category-master",
        title: "Category Master",
        tooltip: "Create/edit/delete/list product categories.",
        icon: "chevron_right"
      },
      {
        path: "masters/sub-category",
        title: "Sub Category Master",
        tooltip: "Create/edit/delete/list product sub-categories.",
        icon: "chevron_right"
      },
      {
        path:"masters/bulk-sub-category",
        title:"Bulk Sub Category",
        tooltip: "Bulk creation of categories subcategories",
        icon:"chevron_right"
      },
      {
        path: "masters/brand",
        title: "Brand",
        tooltip: "Create/edit/delete/list brands.",
        icon: "chevron_right"
      },
      {
        path: "masters/vendor",
        title: "Vendor",
        tooltip: "Create/edit/delete/list vendors.",
        icon: "chevron_right"
      },
      {
        path: "masters/datacenter",
        title: "Datacenter",
        tooltip: "Create/edit/delete/list datacenter.",
        icon: "chevron_right"
      },
      {
        path: "masters/assetusers",
        title: "Asset Users",
        tooltip: "Create/edit/delete/list asset users.",
        icon: "chevron_right"
      },
       {
        path:"masters/bulk-assetusers",
        title:"Bulk Asset Users",
        tooltip: "Bulk creation of asset users",
        icon:"chevron_right"
      },
      {
        path:"po",
        title:"List PO",
        tooltip: "List of Purchase orders",
        icon:"chevron_right"
      },
       {
        path:"bulkpo",
        title:"Bulk Purchase Orders",
        tooltip: "Bulk creation of purchase orders",
        icon:"chevron_right"
      },
       {
        path:"bulkpodetails",
        title:"Bulk Purchase Order Details",
        tooltip: "Bulk creation of purchase order details",
        icon:"chevron_right"
      }
    ],
  },
   
];
